{
  "version": "2.0.0",
  "gitCommitHash": "99675d829dd52544e57d4c80d47aac440434d61c",
  "gitCommitShortHash": "99675d8",
  "gitBranch": "HEAD",
  "gitTags": "",
  "clean": true
}